import React from 'react';
import { Navbar, Footer, AnnouncementBar } from "../components";

const Privacy = () => (
  <>
    <AnnouncementBar />
    <Navbar />
    <div className="container my-4">
      <h2>Privacy Policy</h2>
      <p className="text-muted">Your privacy matters to us. We collect only what we need to fulfill your orders and improve your experience.</p>
      <ul>
        <li>We do not sell your personal data.</li>
        <li>Payments are processed via secure gateways; we don’t store card details.</li>
        <li>You can request deletion of your account data at any time.</li>
      </ul>
    </div>
    <Footer />
  </>
);

export default Privacy;
